import PointApi from '@apis/point/PointApi';
import useSlice from '@hooks/useSlice';
import { GetPointHistoryParams } from '@models/point';

function usePointHistory(shopId: string) {
    const params:GetPointHistoryParams = { shopId, size: 10, page: 0 };
    const { values: pointHistories, fetchNext } = useSlice({
        params,
        queryFn: PointApi.getPointHistory,
        key: 'getPointHistory',
    });
    return {
        pointHistories, fetchNext,
    };
}

export default usePointHistory;
